// Arkusz „chwyty": diagram każdego akordu z bieżącego utworu, w tej wysokości,
// w jakiej jest na ekranie (po transpozycji i kapodastrze). Dotknięcie
// diagramu przełącza na kolejną pozycję chwytu z bazy.

import { znajdzChwyt } from '../music/chwyty.ts';
import { diagramSvg } from '../render/diagram.ts';
import { dodajGotowe, otworzArkusz } from './arkusz.ts';

export function otworzPanelChwytow(akordy: readonly string[]): void {
  const arkusz = otworzArkusz('chwyty w utworze');

  const siatka = document.createElement('div');
  siatka.className = 'og-chwyty';
  arkusz.karta.appendChild(siatka);

  if (akordy.length === 0) {
    const brak = document.createElement('p');
    brak.className = 'zar-stroj-sugestia-brak';
    brak.textContent = 'ten utwór nie ma akordów do pokazania';
    siatka.appendChild(brak);
  }

  for (const nazwa of akordy) {
    const chwyt = znajdzChwyt(nazwa);
    const kafel = document.createElement('button');
    kafel.type = 'button';
    kafel.className = 'og-chwyt';

    const tytul = document.createElement('span');
    tytul.className = 'og-chwyt-nazwa';
    tytul.textContent = nazwa;
    const rysunek = document.createElement('span');
    rysunek.className = 'og-chwyt-rysunek';
    const dopisek = document.createElement('span');
    dopisek.className = 'og-chwyt-dopisek';
    kafel.append(tytul, rysunek, dopisek);

    if (!chwyt) {
      kafel.disabled = true;
      rysunek.textContent = '?';
      dopisek.textContent = 'brak w bazie';
    } else {
      let i = 0;
      const pokaz = (): void => {
        rysunek.innerHTML = diagramSvg(chwyt.pozycje[i]!, nazwa);
        const czesci: string[] = [];
        if (chwyt.pozycje.length > 1) czesci.push(`${i + 1}/${chwyt.pozycje.length}`);
        if (chwyt.basBezChwytu) czesci.push(`bas ${chwyt.basBezChwytu}`);
        dopisek.textContent = czesci.join(' · ');
      };
      pokaz();
      kafel.addEventListener('click', (z) => {
        z.stopPropagation();
        i = (i + 1) % chwyt.pozycje.length;
        pokaz();
      });
    }
    siatka.appendChild(kafel);
  }

  dodajGotowe(arkusz);
}
